import React from "react";
import { injectIntl } from "react-intl";
import { useLocation } from "react-router-dom";
import { ROUTES } from "../../utils/constants";
import { getScenarioNumByPath } from "../../utils/helpers";
import silentAvatar from "../../assets/avatares/sin-sonido.mp4";
import ScenarioBar from "../../components/ScenarioBar";
import Scenario2NextCta from "./Scenario2NextCta";
import "../StartGame.css";
import "./Scenario2.css";

function Scenario2Context3() {
	const location = useLocation();
	const activeScenario = getScenarioNumByPath(location.pathname);

	return (
		<div className="start-game-page sc2-context-page">
			<div className="start-game-inner start-game-inner--prep5">
				<span className="start-game-badge sg5-badge">
					<span className="start-game-badge-dot" aria-hidden />
					Escenario 2 · Diagnóstico
				</span>

				<div className="sg5-scroll">
					<header className="sg5-hero">
						<h1 className="sg5-title">
							Pruebas previas e <span className="sg5-title-accent">impresión</span>
						</h1>
						<p className="sg5-lead">Analítica ya disponible y test de sangre oculta en heces.</p>
					</header>

					<div className="sg5-mosaic">
						<div className="sg5-mosaic-media">
							<div className="sg5-video-shell">
								<div className="start-game-avatar-inner start-game-avatar-inner--silent sg5-video-inner">
									<video autoPlay muted loop playsInline preload="auto" aria-hidden>
										<source src={silentAvatar} type="video/mp4" />
									</video>
								</div>
							</div>
						</div>

						<div className="sg5-mosaic-aside">
							<div className="sg5-aside-card sg5-aside-card--accent">
								<h2 className="sg5-aside-title">Analítica de Atención Primaria</h2>
								<p>
									<strong>Serie roja e hierro:</strong> hemoglobina{" "}
									<span className="sc2-lab-warn">9,8 g/dL</span>, VCM{" "}
									<span className="sc2-lab-warn">72 fL</span>, ferritina{" "}
									<span className="sc2-lab-warn">8 ng/mL</span>, hierro sérico bajo, saturación de
									transferrina baja.
								</p>
								<p>
									<strong>Leucocitos</strong> 7.800/mm³; <strong>plaquetas</strong> 430.000/mm³.
									<strong> Función renal:</strong> creatinina 0,96 mg/dL, FG estimado &gt;60 mL/min.
									<strong> Hepático:</strong> AST/ALT y bilirrubina normales. <strong>Albúmina</strong>{" "}
									3,7 g/dL. <strong>PCR</strong> discretamente elevada.
								</p>
								<p className="sc2-soh-block mb-0">
									<strong>Test de sangre oculta en heces:</strong> positivo en{" "}
									<span className="sc2-lab-warn">2 de 3</span> muestras.
								</p>
							</div>

							<div className="sg5-aside-card">
								<h2 className="sg5-aside-title">Impresión inicial</h2>
								<p className="mb-0">
									Paciente varón de 67 años con síntomas de alarma digestiva baja: anemia ferropénica,
									sangre en heces, pérdida de peso y cambio del ritmo intestinal. La sospecha principal
									es <strong>neoplasia colorrectal</strong>. Diagnóstico diferencial: pólipos avanzados,
									enfermedad inflamatoria intestinal, angiodisplasia, diverticulosis complicada,
									lesiones benignas sangrantes u otras neoplasias digestivas.
								</p>
							</div>
						</div>
					</div>
				</div>

				<div className="sg5-actions">
					<Scenario2NextCta
						navigateTo={ROUTES.SCENARIO2_QUIZ1}
						activeScenario={activeScenario}
						label="Continuar a la pregunta"
					/>
				</div>
			</div>
			<ScenarioBar activeScenario={activeScenario} />
		</div>
	);
}

export default injectIntl(Scenario2Context3);
